import { Route } from '../../modules/RoutesManagement/types';
import envVar from '../../config/envVars';
import httpGet from '../httpClient/httpGet';
import httpPost from '../httpClient/httpPost';
import httpDelete from '../httpClient/httpDelete';

const getQueryParams = (busId?: string, stopId?: string): string => {
  const params = new URLSearchParams();
  if (busId) {
    params.append('busId', busId);
  }
  if (stopId) {
    params.append('stopId', stopId);
  }
  return params.toString();
};

export const getRoutes = async (
  school: string,
  busId?: string,
  stopId?: string
) => {
  const queryParams = getQueryParams(busId, stopId);
  return httpGet(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/routes/school/${school}?${queryParams}`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`
      }
    }
  );
};

export const sendRouteAlert = async (routeId: string) => {
  return httpPost(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/route-alerts`,
    { routeId },
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`,
        'Content-Type': 'application/json'
      }
    }
  );
};

export const deleteRoute = async (routeId: string) => {
  return httpDelete(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/routes/${routeId}`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`
      }
    }
  );
};

export const upsertRoute = async (
  school: string,
  routeData: Partial<Omit<Route, 'school'>>
) => {
  return httpPost(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/routes/school/${school}`,
    routeData,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`,
        'Content-Type': 'application/json'
      }
    }
  );
};
